import AudioPlayerProvider from "@/components/providers/AudioPlayerProvider";
import { Theme } from "@radix-ui/themes";
import { MotionConfig } from "motion/react";
import { StatsigProvider } from "@statsig/react-bindings";
import { LogLevel } from "@statsig/client-core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { retryUnlessUnauthorized } from "@/lib/lutely-api/error-manager";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiProvider from "./ApiProvider";
import AudiolabProvider from "./AudiolabProvider";
import CartProvider from "./CartProvider";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: retryUnlessUnauthorized },
  },
});

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <StatsigProvider
        sdkKey={import.meta.env.VITE_STATSIG_CLIENT_KEY}
        user={{}}
        options={{
          environment: {
            tier: import.meta.env.VITE_STATSIG_ENVIRONMENT || "production",
          },
          logLevel:
            import.meta.env.VITE_STATSIG_ENVIRONMENT === "development"
              ? LogLevel.Warn
              : LogLevel.None,
        }}
      >
        <Theme appearance="inherit">
          <MotionConfig reducedMotion="user">
            <QueryClientProvider client={queryClient}>
              <ApiProvider>
                <AudiolabProvider>
                  <AudioPlayerProvider>
                    <CartProvider>
                      {children}
                      <ReactQueryDevtools
                        buttonPosition="bottom-right"
                        initialIsOpen={false}
                      />
                    </CartProvider>
                  </AudioPlayerProvider>
                </AudiolabProvider>
              </ApiProvider>
            </QueryClientProvider>
          </MotionConfig>
        </Theme>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar
          closeOnClick
          draggable
          draggablePercent={20}
        />
      </StatsigProvider>
    </>
  );
};

export default Providers;
